(() => {
  if (customElements.get('cro-mobile-purchase-bar')) return;
  customElements.define('cro-mobile-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.closest('.product-section');
      this.primary = this.root?.querySelector('.product-single__meta [data-add-to-cart]');
      this.button = this.querySelector('button');
      if (!this.primary || !this.button) return;
      this.root.setAttribute('data-cro-mobile-purchase', '');
      this.media = window.matchMedia('(max-width:768px)');
      this.sync = () => {
        const source = this.primary;
        const style = getComputedStyle(source);
        const rect = source.getBoundingClientRect();
        const text = source.querySelector('[data-add-to-cart-text]')?.textContent.trim() || source.textContent.trim();
        const label = this.querySelector('[data-cro-purchase-text]');
        if (label.textContent !== text) label.textContent = text;
        const loading = source.classList.contains('btn--loading') || source.getAttribute('aria-busy') === 'true';
        this.button.disabled = source.disabled || loading;
        this.button.classList.toggle('btn--loading', loading);
        this.button.setAttribute('aria-busy', String(loading));
        const vars = {font:style.fontFamily,'font-size':style.fontSize,weight:style.fontWeight,'line-height':style.lineHeight,spacing:style.letterSpacing,radius:style.borderRadius,'padding-y':style.paddingTop,'padding-x':style.paddingLeft,height:rect.height+'px',transform:style.textTransform};
        for (const [key,value] of Object.entries(vars)) this.style.setProperty('--cro-purchase-'+key,value);
        this.hidden = !this.media.matches || rect.height === 0 || rect.bottom >= 0;
      };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {this.frame = null; this.sync();});
      };
      this.onClick = () => {
        this.sync();
        if (this.button.disabled) return;
        // Use the original control: one form, validation, bundle and app path.
        this.primary.click();
        this.sync();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.primary, {attributes:true, childList:true, subtree:true, characterData:true});
      this.resize = new ResizeObserver(this.sync);
      this.resize.observe(this.primary);
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll);
      this.media.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.media?.removeEventListener('change', this.sync);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.initialized = false;
    }
  });
})();
